import { useState, useCallback } from 'react';

export default function useEmissionRates(emissionPointId) {
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!emissionPointId) return;
    setLoading(true);
    try {
      const res = await fetch(`/api/emission-points/${emissionPointId}/rates`);
      const data = await res.json();
      setRates(data);
      setError(null);
    } catch (err) {
      console.error("Failed to load emission rates", err);
      setError(err);
      setRates([]);
    } finally {
      setLoading(false);
    }
  }, [emissionPointId]);

  const save = useCallback(async (payloadRates) => {
    if (!emissionPointId) return;
    setLoading(true);

    const sanitized = (payloadRates ?? rates).filter(r =>
      r.emissionRate !== null &&
      r.emissionRate !== undefined &&
      r.emissionRate > 0
    );

    try {
      const res = await fetch(`/api/emission-points/${emissionPointId}/rates`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sanitized),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setError(null);
    } catch (err) {
      console.error("Failed to save emission rates", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [emissionPointId, rates]);

  return { rates, setRates, load, save, loading, error };
}
